<template>
    


<svg :width="width"
:height="height" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="90" height="90" rx="45" fill="#FFDE59"/>
<path d="M60.4151 55.7848L57.6651 56.4348C57.0484 56.5848 56.5651 57.0515 56.4318 57.6682L55.8484 60.1182C55.5318 61.4515 53.8318 61.8682 52.9484 60.8182L47.9651 55.0848C47.5651 54.6182 47.7818 53.8848 48.3818 53.7348C51.3318 53.0182 53.9818 51.3682 55.9318 49.0182C56.2484 48.6348 56.8151 48.5848 57.1651 48.9348L60.8651 52.6348C62.1318 53.9015 61.6818 55.4848 60.4151 55.7848Z" fill="#36373F"/>
<path d="M29.5012 55.7848L32.2512 56.4348C32.8679 56.5848 33.3512 57.0515 33.4846 57.6682L34.0679 60.1182C34.3846 61.4515 36.0846 61.8682 36.9679 60.8182L41.9512 55.0848C42.3512 54.6182 42.1346 53.8848 41.5346 53.7348C38.5846 53.0182 35.9346 51.3682 33.9846 49.0182C33.6679 48.6348 33.1012 48.5848 32.7512 48.9348L29.0512 52.6348C27.7846 53.9015 28.2346 55.4848 29.5012 55.7848Z" fill="#36373F"/>
<path d="M44.9987 28.332C38.5487 28.332 33.332 33.5487 33.332 39.9987C33.332 42.4154 34.0487 44.632 35.282 46.482C37.082 49.1487 39.932 51.032 43.2487 51.5154C43.8154 51.6154 44.3987 51.6654 44.9987 51.6654C45.5987 51.6654 46.182 51.6154 46.7487 51.5154C50.0654 51.032 52.9154 49.1487 54.7154 46.482C55.9487 44.632 56.6654 42.4154 56.6654 39.9987C56.6654 33.5487 51.4487 28.332 44.9987 28.332ZM50.0987 39.632L48.7154 41.0154C48.482 41.2487 48.3487 41.6987 48.432 42.032L48.832 43.7487C49.1487 45.0987 48.432 45.632 47.232 44.9154L45.5654 43.932C45.2654 43.7487 44.7654 43.7487 44.4654 43.932L42.7987 44.9154C41.5987 45.6154 40.882 45.0987 41.1987 43.7487L41.5987 42.032C41.6654 41.7154 41.5487 41.2487 41.3154 41.0154L39.8987 39.632C39.082 38.8154 39.3487 37.9987 40.482 37.8154L42.2654 37.5154C42.5654 37.4654 42.9154 37.1987 43.0487 36.932L44.032 34.9654C44.5654 33.8987 45.432 33.8987 45.9654 34.9654L46.9487 36.932C47.082 37.1987 47.432 37.4654 47.7487 37.5154L49.532 37.8154C50.6487 37.9987 50.9154 38.8154 50.0987 39.632Z" fill="#36373F"/>
</svg>

</template>
<script>
export default {
  name: "PrakerjaIcon",
  props: {
    width: {
      type: Number,
      default: 90,
    },
    height: {
      type: Number,
      default: 90,
    }
  },
};
</script>